"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const DiscoveryIpxeInstructions = () => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (react_1.default.createElement(react_core_1.TextContent, null,
        react_1.default.createElement(react_core_1.Text, { component: "h3" }, t('ai:Adding hosts instructions')),
        react_1.default.createElement(react_core_1.TextList, { component: "ol", type: react_core_1.OrderType.number, style: { marginLeft: 0 } },
            react_1.default.createElement(react_core_1.TextListItem, null, t('ai:Download the example iPXE script file')),
            react_1.default.createElement(react_core_1.TextListItem, null, t('ai:Download the assets in the script file to your iPXE server')),
            react_1.default.createElement(react_core_1.TextListItem, null, t('ai:Inside the example script file, customize the asset URLs to your local server address')),
            react_1.default.createElement(react_core_1.TextListItem, null, t('ai:Set all the hosts to boot using iPXE script file')))));
};
exports.default = DiscoveryIpxeInstructions;
//# sourceMappingURL=DiscoveryIpxeInstructions.js.map